// extracted by mini-css-extract-plugin
module.exports = {"signUpContainer":"SignUpComponent_signUpContainer__3JAfr","signInLinkContainer":"SignUpComponent_signInLinkContainer__20y2j"};